import { Routes } from '@angular/router';

import { AuthService } from '../../auth/auth.service';
import { FormComponent } from '../form';

import { LandingComponent } from './landing.component';

export const LandingRoutes: Routes = [
    {
        path: 'evaluation-landing', // TODO revise naming
        canActivate: [AuthService],
        children: [
            {
                path: '',
                component: LandingComponent,
                children: [
                    {
                        path: 'drafts/:draftId',
                        component: FormComponent,
                    },
                    {
                        path: 'responses/:responseId',
                        component: FormComponent,
                    },
                ],
            },
        ],
    },
];
